import { render, staticRenderFns } from "./color-picker.vue?vue&type=template&id=40a811b8&scoped=true"
import script from "./color-picker.vue?vue&type=script&lang=js"
export * from "./color-picker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a811b8",
  null
  
)

export default component.exports